import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const supportedLngs = ['en', 'ur'];

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    supportedLngs,
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
  });

export default i18n;
